import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    documents: []
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    documents: (state) => state.documents
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    setDocuments (state, documents) {
      state.documents = documents
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_c_m_tasks') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('toggleLoading')
    },
    async fetchDocuments ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_documents', baseParams).getResults()
      commit('setDocuments', response.items)
    }
  }
}
